export default "__VITE_ASSET__BJvnGCIb__"